import { useNavigate } from 'react-router';
import { Award, ChevronLeft, Loader2 } from 'lucide-react';
import { useGetMyCertificatesQuery } from '../../store/api/apiSlice';
import { readableError } from './lib';
import CertificateCard from './components/CertificateCard';

export default function Certificates() {
    const navigate = useNavigate();
    const { data: certificates, isLoading, isError, error } = useGetMyCertificatesQuery();

    return (
        <div className="p-4 md:p-8">
            <button
                type="button"
                onClick={() => navigate('/training')}
                className="mb-4 inline-flex items-center gap-1 text-sm text-gray-600 hover:text-gray-900"
            >
                <ChevronLeft className="h-4 w-4" /> Back to training
            </button>

            <h1 className="mb-6 flex items-center gap-2 text-2xl font-bold text-gray-900 md:text-3xl">
                <Award className="h-7 w-7 text-[#FF6B35]" /> My Certificates
            </h1>

            {isLoading ? (
                <div className="flex items-center justify-center py-20">
                    <Loader2 className="h-7 w-7 animate-spin text-gray-400" />
                </div>
            ) : isError ? (
                <div className="rounded-2xl border border-red-200 bg-red-50 p-6 text-sm text-red-700">
                    {readableError(error, 'Could not load certificates.')}
                </div>
            ) : !certificates || certificates.length === 0 ? (
                <div className="rounded-2xl border border-gray-100 bg-white p-12 text-center">
                    <Award className="mx-auto mb-3 h-10 w-10 text-gray-300" />
                    <p className="font-medium text-gray-900">No certificates yet</p>
                    <p className="mt-1 text-sm text-gray-500">
                        Complete a course to earn your first certificate.
                    </p>
                </div>
            ) : (
                <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
                    {certificates.map((cert) => (
                        <CertificateCard key={cert.id ?? cert.certificateNumber} certificate={cert} />
                    ))}
                </div>
            )}
        </div>
    );
}
